import angular from 'angular';

/* @ngInject */
class Documents {
	constructor(AuthService) {
		this.AuthService = AuthService;
	}

	getClassicationForMimeType(mimeType) {
		const classifications = {
			directory:   'directory',
			generic:     'generic',
			image:       'image',
			audio:       'audio',
			video:       'video',
			script:      'code',
			document:    'document',
			spreadsheet: 'spreadsheet',
			archive:     'archive',
		};

		const mapping = {
			'directory':                                                                 classifications.directory,
			'application/ecmascript':                                                    classifications.script,
			'application/epub+zip':                                                      classifications.archive,
			'application/java-archive':                                                  classifications.archive,
			'application/javascript':                                                    classifications.script,
			'application/json':                                                          classifications.script,
			'application/msword':                                                        classifications.document,
			'application/octet-stream':                                                  classifications.generic,
			'application/ogg':                                                           classifications.audio,
			'application/pdf':                                                           classifications.document,
			'application/rtf':                                                           classifications.document,
			'application/typescript':                                                    classifications.script,
			'application/vnd.amazon.ebook':                                              classifications.document,
			'application/vnd.apple.installer+xml':                                       classifications.script,
			'application/vnd.mozilla.xul+xml':                                           classifications.script,
			'application/vnd.ms-excel':                                                  classifications.spreadsheet,
			'application/vnd.ms-fontobject':                                             classifications.script,
			'application/vnd.ms-powerpoint':                                             classifications.spreadsheet,
			'application/vnd.oasis.opendocument.presentation':                           classifications.document,
			'application/vnd.oasis.opendocument.spreadsheet':                            classifications.spreadsheet,
			'application/vnd.oasis.opendocument.text':                                   classifications.document,
			'application/vnd.openxmlformats-officedocument.presentationml.presentation': classifications.document,
			'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':         classifications.spreadsheet,
			'application/vnd.openxmlformats-officedocument.wordprocessingml.document':   classifications.document,
			'application/vnd.visio':                                                     classifications.generic,
			'application/x-7z-compressed':                                               classifications.archive,
			'application/x-abiword':                                                     classifications.document,
			'application/x-bzip':                                                        classifications.archive,
			'application/x-bzip2':                                                       classifications.archive,
			'application/x-csh':                                                         classifications.script,
			'application/x-rar-compressed':                                              classifications.archive,
			'application/x-sh':                                                          classifications.script,
			'application/x-shockwave-flash':                                             classifications.script,
			'application/x-tar':                                                         classifications.archive,
			'application/xhtml+xml':                                                     classifications.script,
			'application/xml':                                                           classifications.script,
			'application/zip':                                                           classifications.archive,
			'audio/3gpp':                                                                classifications.audio,
			'audio/3gpp2':                                                               classifications.audio,
			'audio/aac':                                                                 classifications.audio,
			'audio/midi':                                                                classifications.audio,
			'audio/x-midi':                                                              classifications.audio,
			'audio/ogg':                                                                 classifications.audio,
			'audio/wav':                                                                 classifications.audio,
			'audio/webm':                                                                classifications.audio,
			'font/otf':                                                                  classifications.script,
			'font/ttf':                                                                  classifications.generic,
			'font/woff':                                                                 classifications.generic,
			'font/woff2':                                                                classifications.generic,
			'image/bmp':                                                                 classifications.image,
			'image/gif':                                                                 classifications.image,
			'image/jpeg':                                                                classifications.image,
			'image/png':                                                                 classifications.image,
			'image/svg+xml':                                                             classifications.image,
			'image/tiff':                                                                classifications.image,
			'image/webp':                                                                classifications.image,
			'image/x-icon':                                                              classifications.image,
			'text/calendar':                                                             classifications.document,
			'text/css':                                                                  classifications.script,
			'text/csv':                                                                  classifications.spreadsheet,
			'text/html':                                                                 classifications.script,
			'text/plain':                                                                classifications.document,
			'video/3gpp':                                                                classifications.video,
			'video/3gpp2':                                                               classifications.video,
			'video/mp4':                                                                 classifications.video,
			'video/mpeg':                                                                classifications.video,
			'video/ogg':                                                                 classifications.video,
			'video/webm':                                                                classifications.video,
			'video/x-msvideo':                                                           classifications.video,
		};

		let classification = classifications.generic;

		if (mimeType) {
			angular.forEach(mapping, (value, key) => {
				if (mimeType === key) {
					classification = value;
				}
			});
		}

		return classification;
	};

	getDownloadURLForDocumentId(documentId) {
		const query = (this.AuthService.isLoggedIn()) ? (`?token=${this.AuthService.getToken()}`) : ('');

		return `${process.env.API_ENDPOINT}documents/${documentId}/download${query}`;
	}

	getDownloadURLForDocumentVersionId(documentVersionId) {
		const query = (this.AuthService.isLoggedIn()) ? (`?token=${this.AuthService.getToken()}`) : ('');

		return `${process.env.API_ENDPOINT}document-versions/${documentVersionId}/download${query}`;
	}

	getDownloadURLForPermissionsReport() {
		const query = (this.AuthService.isLoggedIn()) ? (`?token=${this.AuthService.getToken()}`) : ('');

		return `${process.env.API_ENDPOINT}documents/permissions-report${query}`;
	}

	getGooglePreviewURLForURL(url) {
		return `https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(url)}`;
	}
}

export default Documents;


// WEBPACK FOOTER //
// ./src/js/services/documents/index.js